export const blogFilters = {
  title: null,
  tag: null,
};

export const staticBlogFilters = {
  title: null,
  tag: null,
};

export const newsFilters = {
  title: null,
  tag: null,
};

export const staticNewsFilters = {
  title: null,
  tag: null,
};

export const enqFilters = {
  first_name: null,
  last_name: null,
  phone: null,
  type: null,
  stage: null,
  network_details: {},
  network_id: null,
};

export const staticEnqFilters = {
  first_name: null,
  last_name: null,
  phone: null,
  type: null,
  status: null,
};

export const revFilters = {
  term: null,
  source: null,
  is_published: null,
  rating: null,
  location_id: null,
  from_date: null,
  to_date: null,
};

export const surveyFilters = {
  term: null,
};

export const staticRevFilters = {
  term: null,
  source: null,
  is_published: null,
  rating: null,
  location_id: null,
  from_date: null,
  to_date: null,
};

export const invFilters = {
  type: null,
  is_mail_sent: null,
};

export const staticInvFilters = {
  type: null,
  is_mail_sent: null,
};

export const resFilters = {};

export const staticResFilters = {};

export const employeeFilters = {
  first_name: null,
  accounting_type: null,
  role_details: {},
  role_id: null,
};

export const webEmpFilters = {
  first_name: "",
  email: "",
  type: "",
  source: "",
  is_lead_created: "",
};

export const staticWebEnqFilters = {
  first_name: null,
  email: null,
  type: null,
  source: null,
  is_lead_created: null,
};
